export interface PedidoCompraPainelAprovacao {
    CCRSTATUS: string;
    CC7FORNECE: string;
    DC7EMISSAO: Date | undefined;
    CA2NREDUZ: string;
    CC7CC: string;
    CCTTDESC01: string;
    CCRNUM: string;
    NCRTOTAL: number;
    NCRVALLIB: number;
    DCRDATALIB: Date | undefined;
    CCRUSERLIB: string;
    CCROBS: string;
    CCRNIVEL: string;
    CCRUSER: string;
};

export const defaultPedidoCompraPainelAprovacao = (): PedidoCompraPainelAprovacao => {
    return {
        CCRSTATUS: '',
        CC7FORNECE: '',
        DC7EMISSAO: undefined,
        CA2NREDUZ: '',
        CC7CC: '',
        CCTTDESC01: '',
        CCRNUM: '',
        NCRTOTAL: 0,
        NCRVALLIB: 0,
        DCRDATALIB: undefined,
        CCRUSERLIB: '',
        CCROBS: '',
        CCRNIVEL: '',
        CCRUSER: ''
    };
};

export interface PedidoCompraPainelAprovacaoItem extends PedidoCompraPainelAprovacao{
    detalhes: Array<PedidoCompraPainelAprovacao>
};

export const defaultPedidoCompraPainelAprovacaoItem = (): PedidoCompraPainelAprovacaoItem => {
    return {
        CCRSTATUS: '',
        CC7FORNECE: '',
        DC7EMISSAO: undefined,
        CA2NREDUZ: '',
        CC7CC: '',
        CCTTDESC01: '',
        CCRNUM: '',
        NCRTOTAL: 0,
        NCRVALLIB: 0,
        DCRDATALIB: undefined,
        CCRUSERLIB: '',
        CCROBS: '',
        CCRNIVEL: '',
        CCRUSER: '',
        detalhes: [],
    };
};

export interface PedidoCompraPainelAprovacaoLista {
    items: Array<PedidoCompraPainelAprovacaoItem>;
};

export const defaultPedidoCompraPainelAprovacaoLista = (): PedidoCompraPainelAprovacaoLista => {
    return {
        items: [defaultPedidoCompraPainelAprovacaoItem()],
    };
}